if (!customElements.get('pdp-comparison')) {
  class PdpComparison extends HTMLElement {
    connectedCallback() {
      this.section = this.querySelector('.pdp-comparison') || this;
      this.frame = 0;
      this.listening = false;
      this.reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.desktopQuery = window.matchMedia('(min-width: 761px)');

      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.updateShift();
        });
      };

      this.onChange = () => {
        if (this.canParallax()) {
          this.bindScroll();
          this.updateShift();
        } else {
          this.unbindScroll();
          this.setShift(0);
        }
      };

      this.reduceQuery.addEventListener('change', this.onChange);
      this.desktopQuery.addEventListener('change', this.onChange);

      if ('IntersectionObserver' in window) {
        this.sectionObserver = new IntersectionObserver(
          (entries) => {
            const visible = entries.some((entry) => entry.isIntersecting);
            if (visible) this.bindScroll();
            else this.unbindScroll();
          },
          { root: null, rootMargin: '100% 0px', threshold: 0 }
        );
        this.sectionObserver.observe(this);
      } else if (this.canParallax()) {
        this.bindScroll();
      }

      this.onChange();
    }

    setShift(px) {
      const value = `${Number(px).toFixed(1)}px`;
      this.style.setProperty('--parallax-y', value);
      this.section?.style.setProperty('--parallax-y', value);
    }

    disconnectedCallback() {
      this.sectionObserver?.disconnect();
      this.unbindScroll();
      this.reduceQuery?.removeEventListener('change', this.onChange);
      this.desktopQuery?.removeEventListener('change', this.onChange);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.sectionObserver = null;
    }

    canParallax() {
      return this.desktopQuery.matches && !this.reduceQuery.matches;
    }

    bindScroll() {
      if (this.listening || !this.canParallax()) return;
      this.listening = true;
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.updateShift();
    }

    unbindScroll() {
      if (!this.listening) return;
      this.listening = false;
      window.removeEventListener('scroll', this.onScroll);
      if (this.frame) {
        cancelAnimationFrame(this.frame);
        this.frame = 0;
      }
    }

    updateShift() {
      if (!this.canParallax()) {
        this.setShift(0);
        return;
      }

      const rect = this.getBoundingClientRect();
      const center = rect.top + rect.height / 2 - (window.innerHeight || 1) / 2;
      const shift = Math.max(-72, Math.min(72, -center * 0.12));
      this.setShift(shift);
    }
  }

  customElements.define('pdp-comparison', PdpComparison);
}
